<template>
    <PageLayout :has-buttons="true" :has-title="false" content-class="p-0" :has-page-scroll="false">
        <template #content>
            <section
                class="card w-100 h-100 d-flex flex-column align-items-center justify-content-center"
                v-if="isLoadError || isFormLoading || isSaveInProgress"
            >
                <div class="d-flex flex-column align-items-start" v-if="isLoadError && !isFormLoading">
                    <h5 class="fw-bold">Error</h5>
                    <p class="font-size-xl mb-1">
                        There was problem while loading the Company Security Setup. Please try again.
                    </p>
                    <button class="btn btn-primary" @click="loadCompanySecuritySetup()">Try Again</button>
                </div>
                <div v-if="!isLoadError && isFormLoading" class="d-flex flex-column">
                    <i class="fas fa-clipboard-list fa-7x text-primary animated flash infinite slow mb-2"></i>
                    <span class="font-size-xl">Loading Company Security Setup...</span>
                </div>
                <div v-if="isSaveInProgress" class="d-flex flex-column align-items-center">
                    <i class="far fa-save fa-7x text-primary animated flash infinite slow mb-2"></i>
                    <span class="font-size-xl text-center">Saving Company Security Setup...</span>
                </div>
            </section>
            <template v-if="!isLoadError && !isFormLoading && !isSaveInProgress">
                <div id="HosPal_New_Referral">
                    <div>
                        <div class="card-body form-content p-3 pt-0 mx-lg-6">
                            <div v-if="isSignatureValidated" class="mb-3">
                                <SecurityAuthentication :securitySetup="securitySetup" />
                            </div>
                        </div>
                    </div>
                    <footer
                        class="d-flex justify-content-center form-footer py-2 gap-2"
                        v-if="!isLoadError && !isFormLoading && !isSaveInProgress"
                    >
                        <button type="button" class="btn btn-primary me-2" @click="save()">Save</button>
                        <button class="btn btn-outline-primary" @click="cancel()">Cancel</button>
                    </footer>
                </div>
            </template>
        </template>
    </PageLayout>
</template>

<script lang="ts" src="./CompanySecuritySetup.ts"></script>
